import{post } from '@/utils/request';
import{overseasserver} from '@/utils/baseUrl';

//客商列表查询
export async function list(params) {
    return post(overseasserver+'/kh/list', params, true)
}
//保存客商
export async function save(params) {
    return post(overseasserver+'/kh/save', params, true)
}
//查询国别
export async function nationalList(params) {
    return post(overseasserver+'/currency/nationalList', params, true)
}
//保存国别
export async function savenational(params) {
    return post(overseasserver+'/currency/saveNational', params, true)
}
//客户类型
export async function khtypeList(params) {
    return post(overseasserver+'/currency/khtypeList', params, true)
}
//仓库列表
export async function warehouselist(params) {
    return post(overseasserver+'/warehouse/list', params, true)
}
//保存仓库
export async function warehousesave(params) {
    return post(overseasserver+'/warehouse/save', params, true)
}
//品种列表
export async function productlist(params) {
    return post(overseasserver+'/product/list', params, true)
}
//保存品种
export async function productsave(params) {
    return post(overseasserver+'/product/save', params, true)
}
//公司列表
export async function companylist(params) {
    return post(overseasserver+'/company/list', params, true)
}
//保存公司
export async function companysave(params) {
    return post(overseasserver+'/company/save', params, true)
}
//列表
export async function classificationList(params) {
    return post(overseasserver+'/product/classificationList', params, true)
}
//保存
export async function saveClassification(params) {
    return post(overseasserver+'/product/saveClassification', params, true)
}
//列表
export async function costlist(params) {
    return post(overseasserver+'/cost/list', params, true)
}
//保存
export async function costsave(params) {
    return post(overseasserver+'/cost/save', params, true)
}
//类型
export async function costType(params) {
    return post(overseasserver+'/cost/costType', params, true)
}